import React, { useState, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../redux/store";
import { fetchLeaderboard } from "../../features/auth/store/userSlice";
import { FaSpinner } from "react-icons/fa";

const Leaderboard = () => {
  const [toggle, setToggle] = useState<string>("monthly");
  const dispatch = useAppDispatch();
  const { leaderboard, loading } = useAppSelector(
    (state: RootState) => state.users,
  );

  useEffect(() => {
    dispatch(fetchLeaderboard(toggle));
  }, [toggle, dispatch]);

  return (
    <div
      // Changed: Replaced col-4 with dynamic flex-col structure, updated background size for scaling
      className="flex flex-col gap-4 p-4 rounded-xl flex-1 min-w-0 w-full dark:bg-zinc-900 border border-gray-200/50 dark:border-zinc-800"
      style={{
        backgroundImage: `url(/images/bg.png)`,
        backgroundPosition: "center top",
        backgroundSize: "cover", // Changed from 400% 300% to adapt fluidly to varying dynamic widths
        backgroundRepeat: "no-repeat",
      }}
    >
      <Header toggle={toggle} setToggle={setToggle} />
      <Body data={leaderboard || []} loading={loading} type={toggle} />
    </div>
  );
};

export default Leaderboard;

const Header = ({
  toggle,
  setToggle,
}: {
  toggle: string;
  setToggle: (val: string) => void;
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-between sm:items-center w-full">
      <div className="flex items-center gap-2">
        <img
          src="/crown.png"
          alt=""
          className="size-8 sm:size-10 object-contain"
        />
        <span className="lt-xl-semibold-main-dark text-gray-600 dark:text-white dark:bg-white/10 px-2 py-0.5 rounded text-sm sm:text-base">
          Leaderboard
        </span>
      </div>
      <div className="rounded-2xl p-[4px] sm:p-[6px] flex items-center gap-1 bg-BG-light dark:bg-zinc-800/80 backdrop-blur-sm transition-colors w-full sm:w-auto">
        {["monthly", "allTime"].map((item, index) => (
          <button
            key={index}
            className={`flex-1 py-[6px] px-[12px] text-center rounded-full transition-all ${
              toggle === item
                ? "inter-xs-semibold-white bg-toggleBG-light dark:bg-blue-600 dark:text-white"
                : "inter-xs-medium-toggleBG-dark text-gray-500 dark:text-zinc-400"
            }`}
            onClick={() => setToggle(item)}
          >
            {item === "monthly" ? "Monthly" : "All Time"}
          </button>
        ))}
      </div>
    </div>
  );
};

const Body = ({
  data,
  loading,
  type,
}: {
  data: any[];
  loading: boolean;
  type: string;
}) => {
  if (loading) {
    return (
      <div className="w-full h-full flex justify-center items-center py-10">
        <FaSpinner className="animate-spin text-blue-500 dark:text-white" />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 mt-2 w-full">
      {data.map((user, index) => (
        <div
          key={user.id || index}
          className="flex items-center justify-between rounded-lg px-3 sm:px-4 py-2.5 bg-BG-light dark:bg-zinc-800/90 dark:border dark:border-zinc-700/50 shadow-sm w-full"
        >
          <div className="flex items-center min-w-0 flex-1">
            <Position index={index} />
            <img
              className="size-10 sm:size-11 rounded-full object-cover flex-shrink-0"
              src={user.image_url || "/IVCartoon.png"}
              alt={user.username}
            />
            <div className="flex flex-col justify-center ml-3 min-w-0">
              <span className="inter-xs-bold-black dark:text-zinc-100 truncate text-sm">
                {user.username || `${user.firstname}`}
              </span>
              <span className="inter-xs-bold-pry-600 text-[10px] sm:text-xs dark:text-blue-400 mt-0.5">
                {type === "monthly"
                  ? user.monthly_accumulated_points
                  : user.alltime_accumulated_points}{" "}
                pts
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const Position = ({ index }: { index: number }) => {
  const commonClassses =
    "size-6 flex items-center justify-center rounded-full p-2 mr-3 flex-shrink-0";
  if (index < 3) {
    const lbColor = ["#FFBF00", "#C0C0C0", "#CD7F32"];
    const bgColor = lbColor[index];
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-white text-[10px]`}
        style={{ backgroundColor: bgColor }}
      >
        {index + 1}
      </span>
    );
  } else {
    return (
      <span
        className={`${commonClassses} satoshi-sm-bold-toggleBG-dark text-[10px] dark:text-zinc-300 border border-border-light dark:border-zinc-600`}
      >
        {index + 1}
      </span>
    );
  }
};
